<template>
  <div id="app">
    <homeHeaderfrom></homeHeaderfrom>
              <suspendButton ></suspendButton>
      <scroll ref="scroll">

      <router-view ref="theRouter"  ></router-view>
        <homeFooter></homeFooter>
      </scroll>
  </div>
</template>
<script>
import scroll from './components/common/scroll/index.vue';
import suspendButton from './components/suspendButton/index.vue';
import homeHeaderfrom from './components/homeHeader/index.vue';
import homeFooter from './components/homeFooter/index.vue';
export default {
  data () {
    return {
      activeDate: ''
    };
  },

  components: {homeHeaderfrom, homeFooter, suspendButton, scroll},

  computed: {},

  mounted () {
    if (window.screen.width  <= 1024) {
  // 当前设备是移动设备 
  this.$store.commit("setUnit",false)

}else{
  this.$store.commit("setUnit",true)
}
  },

  methods: {
    go_top () { // 返回顶部
      this.$refs.scroll.go(0)
    }

  }
}

</script>
<style scoped>
.page {
  background-color: #fff;
  width: 100%;

}

</style>